import { AxiosConfigSuperAdmin } from "SuperAdmin/Config/AxiosConfig";
import { refreshToken } from "Explore/Services/Auth";
export const getAllAccounts = (page, rowsPerPage, filters, callback) => {
  const axios = AxiosConfigSuperAdmin();
  let url = `/accounts/?page=${page}&rowsPerPage=${rowsPerPage}`;
  if (filters.entity_id) {
    url += `&entity_id=${filters.entity_id}`;
  }
  if (filters.entity_type) {
    url += `&entity_type=${filters.entity_type}`;
  }
  if (filters.name) {
    url += `&name=${filters.name}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() =>
          getAllAccounts(page, rowsPerPage, filters, callback)
        );
      } else {
        callback(err.response.data);
      }
    });
};
export const getAccountInformationById = (id, callback) => {
  const axios = AxiosConfigSuperAdmin();
  const url = `/accounts/${id}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
  // callback({
  //   image:
  //     "https://ws.engr.illinois.edu/directory/viewphoto.aspx?id=4947&s=400&type=portrait",
  //   name: "Jiawei Han",
  //   email: "hanj@illinois.edu",
  //   department: {
  //     id: "4ff04b4f3a2e1012fe2c157b87526db02989f7d065d084161bee65ca",
  //     inst_name: "University of Illinois Urbana-Champaign",
  //     name: ["Computer Science"],
  //   },
  //   position: "Michael Aiken Chair",
  //   homepage: "https://cs.illinois.edu/about/people/department-faculty/hanj",
  //   mapped_profile: "391c611824b5afa20d70c72b241a76a9b6d619e4659b4768ea9fad29",
  //   activate: true,
  //   roles: [
  //     {
  //       type: 2,
  //       id: "faculty_001",
  //       name: "Jiawei Han",
  //       management_scope:
  //         "391c611824b5afa20d70c72b241a76a9b6d619e4659b4768ea9fad29",
  //       permissions: ["VIEW_PROFILE", "UPDATE_PROFILE"],
  //     },
  //     {
  //       type: 0,
  //       id: "inst_001",
  //       name: "University of Illinois Urbana-Champaign",
  //       management_scope:
  //         "5238412c9a39557cec5a7d5b42e0b84abbd82ae20fe54cbfae93ad8f",
  //       permissions: {
  //         unit: [
  //           "VIEW_UNIT_INFORMATION",
  //           "UPDATE_UNIT_SUMMARY",
  //           "UPDATE_UNIT_ENTITY",
  //         ],

  //         faculty_profile: [
  //           "VIEW_FACULTY_MEMBERS",
  //           "UPDATE_FACULTY_MEMBER_SUMMARY",
  //           "UPDATE_FACULTY_MEMBER_ENTITY",
  //         ],
  //       },
  //     },
  //   ],
  // });
};
export const updateAssignRole = (account_id, role_id, callback) => {
  const axios = AxiosConfigSuperAdmin();
  const url = `/accounts/${account_id}/assign_role`;
  axios
    .put(url, { role_id: role_id })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => updateAssignRole(account_id, role_id, callback));
      } else {
        callback(err.response.data);
      }
    });
};

export const updateAccountByID = (account_id, payload, callback) => {
  const axios = AxiosConfigSuperAdmin();
  const url = `/accounts/${account_id}`;
  axios
    .put(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => updateAccountByID(account_id, payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};

export const createAccount = (payload, callback) => {
  const axios = AxiosConfigSuperAdmin();
  const url = `/accounts`;
  axios
    .post(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => createAccount(payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};
